<div class="d-lg-block d-none">
  <fgb-banner [title]="'auction.page.title' | translate"></fgb-banner>
</div>

<ng-container *ifScreenSize="screenType.Mobile">
  <fgb-member-card-with-wallet-button />
</ng-container>

<fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

<!-- Auction Image -->
<div class="container mt-3">
  <a href="https://orioles.auctions.mlb.com/" class="card rounded" target="_blank">
    <ng-container *ifScreenSize="screenType.Desktop">
      <img src="assets/images/rewards/DesktopAuctionsBanner.jpg" class="w-100" />
    </ng-container>
    <ng-container *ifScreenSize="screenType.Mobile">
      <img src="assets/images/rewards/MobileAuctionsBanner.jpg" class="w-100" />
    </ng-container>
  </a>
</div>

<div class="container mt-3">
  <fgbcl-auction-list></fgbcl-auction-list>
</div>
